import Grid from "@mui/material/Grid";
import { useOrganization } from "../../store/organization";
import useMediaQuery from "@mui/material/useMediaQuery";
import { BookButton } from "./BookButton";
import {usePartnerLanding} from "../../store/partnerLanding";

const icons = {
  calendar: require("../../assets/icons/calendar.svg").default,
  eBike: require("../../assets/icons/eBike.svg").default,
  bag: require("../../assets/icons/bag.svg").default,
};

export function ProgramBreakdown({toggleZipModalOpen}) {
  const { organization } = useOrganization();
  const partnerLanding = usePartnerLanding();
  const landingDetails = organization.data.landingDetails;

  return (
    <Grid
      container={true}
      item={true}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      mt={{ xs: "32px", md: "80px" }}
      py={{ xs: "32px", md: "80px" }}
      sx={{
        backgroundColor: "#fde82b",
      }}
    >
      <Grid
        item={true}
        lg={7}
        md={6}
        xs={10.5}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <h2 className="tw-font-bold tw-text-2xl tw-text-center">{landingDetails.programBreakdownTitle}</h2>

        <div className={`tw-mt-8`}>
          {landingDetails.programBreakdown.map((breakdown) => (
            <div className="tw-flex tw-items-center tw-flex-row tw-mb-8" key={breakdown.id}>
              <div className="tw-mr-5">
                <img width={35} height={28} src={icons[breakdown.icon]} alt="" style={{ objectFit: "contain" }}/>
              </div>

              <div>
                <h5 className="tw-mb-1 tw-font-bold">{breakdown.headerText}</h5>
                <p>{breakdown.description}</p>
              </div>
            </div>
          ))}
        </div>

        {!partnerLanding.isMobile && <BookButton color="black" onClick={toggleZipModalOpen}/>}
      </Grid>
    </Grid>
  );
}
